import React from 'react';
import TrashCanCross from '@splunk/react-icons/TrashCanCross';
import Button, { type ButtonPropsBase } from '@splunk/react-ui/Button';
import { variables } from '@splunk/themes';
import styled from 'styled-components';

// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
const revertPointerEvents: React.CSSProperties = { pointerEvents: 'initial' };

const removeIcon = (
    <TrashCanCross
        data-test="remove-icon"
        aria-hidden={false}
        style={revertPointerEvents}
    />
);

export interface RemoveButtonProps {
    onRemoveClick?: React.MouseEventHandler;
    RemoveIcon?: ButtonPropsBase['icon'];
}

interface RemoveButtonExtraProps {
    labelledBy?: string;
}

const StyledButton = styled(Button)`
    width: ${variables.inputHeight};
`;

export const RemoveButton = ({
    onRemoveClick,
    RemoveIcon = removeIcon,
    labelledBy,
}: RemoveButtonProps & RemoveButtonExtraProps) => {
    if (!onRemoveClick) {
        return null;
    }

    return (
        <StyledButton
            data-test="item-remove"
            appearance="subtle"
            icon={RemoveIcon}
            onClick={onRemoveClick}
            aria-labelledby={labelledBy}
        />
    );
};
